<div class="form-group padding-none margin-none">
  <mat-card class="shadow-none header-text-no-margin">
    <mat-card-header>
      <div mat-card-avatar>
        <mat-icon color="primary" class="title-icon">person</mat-icon>
      </div>
      <mat-card-title>
        <h2>{{'user.heading.access_rights'|translate }}</h2>
      </mat-card-title>
      <mat-card-subtitle *ngIf="!canUpdateAccessRight">
        {{ 'user.content.access_allowing_watcher_beloging_to_group'|translate }}
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="form-group">
      <form [formGroup]="form" class="full-width" *ngIf="canUpdateAccessRight">
        <mat-list>
          <mat-list-item>
            <span matLine>{{ 'public.all' | translate }}</span>
            <mat-checkbox [checked]="allOptionChecked" [indeterminate]="anyOptionChecked" (change)="setAll($event.checked)"
              color="primary">
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item *ngFor="let key of form.controls | keyvalue">
            <span matLine>{{ featureLabels[key.key] | translate }}</span>
            <mat-checkbox [formControlName]="key.key"></mat-checkbox>
          </mat-list-item>
        </mat-list>
      </form>
    </mat-card-content>
  </mat-card>
</div>
